export enum ClosureCodesColumns {
  MENU = "menu",
  ID = "id",
  NAME = "name",
  DISPLAY_NAME = "displayName",
  ARCHIVE_IN = "archiveIn",
  DELETE_IN = "deleteIn",
  ARCHIVE_FROM = "archiveFrom",
  BAD_DEBT_RECORD = "badDebtRecord",
  DESCRIPTION = "description",
}

export const ClosureCodeInitialValue = {
  id: -1,
  name: "",
  displayName: "",
  description: "",
  archiveDuration: "",
  archiveDurationPeriod: "",
  deletionDuration: "",
  deletionDurationPeriod: "",
  isStartFromCaseClosedDate: false,
  badDebtRecord: "",
};

export const ClosureCodeDrawerInitialDetails = {
  isVisible: false,
  codeId: -1,
  action: "",
}

export enum ArchiveDuration {
  MONTHS = "Months"
}

export enum BadDebtType {
  E = "E",
  S = "S"
}